import { map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '@base/exceptions.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApplicationHttpClient } from '@base/http-client';
import { Injectable } from '@angular/core';
import { moduleRoutes } from './urlmap';
import { IErrorResponse, ITableauUser, ITableauProject, ITableauWorkbook, ITableauGroup, } from '@interfaces';

@Injectable()
export class TableauService {
  private mapRoutes = moduleRoutes;

  private usersState: ITableauUser[] = [];
  private bsUsersState = new BehaviorSubject<ITableauUser[]>(this.usersState);

  private projectsState: ITableauProject[] = [];
  private bsProjectsState = new BehaviorSubject<ITableauProject[]>(this.projectsState);

  private workbooksState: ITableauWorkbook[] = [];
  private bsWorkbooksState = new BehaviorSubject<ITableauWorkbook[]>(this.workbooksState);

  private groupsState: ITableauGroup[] = [];
  private bsGroupsState = new BehaviorSubject<ITableauGroup[]>(this.groupsState);

  private showNavBackButton = false;
  private bsShowNavBackButton = new BehaviorSubject<boolean>(this.showNavBackButton);
  private bsShowTags = new BehaviorSubject<boolean>(false);

  constructor(
    private http: ApplicationHttpClient,
    private exceptionService: ExceptionService,
  ) {
    //
  }

  getUsers() {
    // this.notifyFetching(true);
    return this.http.Get(this.mapRoutes.getUsers).pipe(
      map((res: ITableauUser[]) => {
        // this.notifyFetching(false);
        this.usersState = res;
        this.bsUsersState.next(this.usersState);
        return res;
      },
      (err: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(err); })
    );
  }

  getProjects() {
    return this.http.Get(this.mapRoutes.getProjects).pipe(
      map((res: ITableauProject[]) => {
        this.projectsState = res;
        this.bsProjectsState.next(this.projectsState);
        return res;
      },
      (err: HttpErrorResponse) => {
        const error: IErrorResponse = this.exceptionService.errorHandling(err);
      })
    );
  }

  getWorkbooks() {
    return this.http.Get(this.mapRoutes.getWorkbooks).pipe(
      map((res: ITableauWorkbook[]) => {
        this.workbooksState = res;
        this.bsWorkbooksState.next(this.workbooksState);
        return res;
      },
      (err: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(err); })
    );
  }

  getGroups() {
    return this.http.Get(this.mapRoutes.getGroups).pipe(
      map((res: ITableauGroup[]) => {
        this.groupsState = res;
        this.bsGroupsState.next(this.groupsState);
        return res;
      },
      (err: HttpErrorResponse) => { const error: IErrorResponse = this.exceptionService.errorHandling(err); })
    );
  }

  setProjects(projects: ITableauProject[]) {
    this.projectsState = projects;
    this.bsProjectsState.next(this.projectsState);
  }

  setWorkbooks(workbooks: ITableauWorkbook[]) {
    this.workbooksState = workbooks;
    this.bsWorkbooksState.next(this.workbooksState);
  }

  setGroups(groups: ITableauGroup[]) {
    this.groupsState = groups;
    this.bsGroupsState.next(this.groupsState);
  }

  observeUsers(): Observable<ITableauUser[]> {
    return this.bsUsersState.asObservable();
  }

  observeWorkbooks(): Observable<ITableauWorkbook[]> {
    return this.bsWorkbooksState.asObservable();
  }

  observeGroups(): Observable<ITableauGroup[]> {
    return this.bsGroupsState.asObservable();
  }

  setNavBackButtonStatus(status: boolean) {
    this.showNavBackButton = status;
    this.bsShowNavBackButton.next(this.showNavBackButton);
  }

  observeNavBackButton(): Observable<boolean> {
    return this.bsShowNavBackButton.asObservable();
  }

  setDisplayTagsStatus(status: boolean) {
    this.bsShowTags.next(status);
  }

  displayTags(): Observable<boolean> {
    return this.bsShowTags.asObservable();
  }
}
